import React, { useState } from "react";
import { Loading, SecondaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import List32 from "@carbon/icons-react/lib/list/32";
import Grid32 from "@carbon/icons-react/lib/grid/32";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import commonStyles from "../../common/styles/Common.styles";
import boxScoreStyles from "../../game-stats/styles/BoxScore.styles";
import TeamLogo from "../../team/components/TeamLogo";
import PrintButton from "../../common/components/print/PrintButton";
import ParticipatingPlayers from "../../game-stats/components/ParticipatingPlayers";
import { usePlayersFootballContext } from "../../../state/players/football-context";
import PlayerFormat from "../../../util/player-format";

const ParticipatingPlayersContainer = ({ boxScore = {} }) => {
	const commonClasses = commonStyles();
	const classes = boxScoreStyles();

	const { homeTeam, awayTeam } = boxScore;

	const [currentTeam, setCurrentTeam] = useState(awayTeam);
	const [isLoading, setIsLoading] = useState(false);

	const hiddenUniforms = [
		PlayerFormat.TeamUniform,
		PlayerFormat.NotSpecifiedUniform
	];

	const { state, setView } = usePlayersFootballContext({
		team: currentTeam
	});

	const participatingPlayers = state
		.participatingPlayers()
		.filter((player) => !hiddenUniforms.includes(player.uniform));

	const viewType = state.view();

	return (
		<Box className={commonClasses.container}>
			{isLoading && (
				<div style={{ position: "relative" }}>
					<div style={{ position: "absolute", width: "100%" }}>
						<Loading isFetching />
					</div>
				</div>
			)}
			{currentTeam && (
				<>
					<Box
						className={commonClasses.headerContainer}
						display="flex"
						justifyContent="space-between"
					>
						<Grid container spacing={1}>
							<Grid
								className={currentTeam.id === awayTeam.id ? classes.selectedTeam : ""}
								item
							>
								<SecondaryButton
									label={awayTeam.teamName}
									onClick={() => setCurrentTeam(awayTeam)}
									startIcon={<TeamLogo team={awayTeam} hideName />}
								/>
							</Grid>
							<Grid
								className={currentTeam.id === homeTeam.id ? classes.selectedTeam : ""}
								item
							>
								<SecondaryButton
									label={homeTeam.teamName}
									onClick={() => setCurrentTeam(homeTeam)}
									startIcon={<TeamLogo team={homeTeam} hideName />}
								/>
							</Grid>
						</Grid>
						<Box className={classes.toggleButtonBox}>
							<ToggleButtonGroup
								exclusive
								value={viewType}
								onChange={(_, value) => {
									if (value) setView(value);
								}}
							>
								<ToggleButton size="small" value="list">
									<List32 />
								</ToggleButton>
								<ToggleButton size="small" value="grid">
									<Grid32 />
								</ToggleButton>
							</ToggleButtonGroup>

							<PrintButton isLoading={isLoading} setIsLoading={setIsLoading} />
						</Box>
					</Box>
					<Box
						className={classNames(commonClasses.contentContainer, classes.content)}
					>
						<Box align="center" px={4} pb={4}>
							<TeamLogo team={currentTeam} hideName size="large" />
							<Typography variant="h4" align="center">
								{currentTeam.teamName}
							</Typography>
							<ParticipatingPlayers
								team={currentTeam}
								viewType={viewType}
								participatingPlayers={participatingPlayers}
							/>
						</Box>
					</Box>
				</>
			)}
		</Box>
	);
};

// ParticipatingPlayersContainer.whyDidYouRender = true;

export default ParticipatingPlayersContainer;
